import { Palette } from '@mui/material/styles';
import { colors } from '@mui/material';

declare module '@mui/material/styles/createPalette' {
  interface Palette {
    white: string;
    black: string;
    icon: string;
  }
}

const white = '#FFFFFF';
const black = '#000000';

export default {
  black,
  white,
  primary: {
    contrastText: white,
    dark: '#34C1E0',
    main: '#34C1E0',
    light: '#34C1E0',
  },
  secondary: {
    contrastText: white,
    dark: '#34C1E0',
    main: '#34C1E0',
    light: '#34C1E0',
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600],
  },
  link: colors.blue[800],
  icon: colors.blueGrey[600],
  background: {
    default: '#F4F6F8',
    paper: white,
  },
  divider: colors.grey[300],
};
